import { render, staticRenderFns } from "./ydzd.vue?vue&type=template&id=3572c71d&scoped=true"
import script from "./ydzd.vue?vue&type=script&lang=js"
export * from "./ydzd.vue?vue&type=script&lang=js"
import style0 from "./ydzd.vue?vue&type=style&index=0&id=3572c71d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572c71d",
  null
  
)

export default component.exports